import React from 'react';
import styled from 'styled-components';

import MaterialSymbol from '#/components/basic/icons/MaterialSymbol';
import UnstyledLink from '#/components/basic/Link/UnstyledLink';
import Tooltip from '#/components/basic/tooltip/Tooltip';
import { urls } from '#/config/constants';

import { MARKET_CLOSES_PERIODICALLY_LINK_TOOLTIP } from './intermittentMarketsCopy';

// Fixed icon size so it stays legible even inside small-text contexts
const IconLink = styled(UnstyledLink)`
  display: inline-flex;
  font-size: var(--medium);
  vertical-align: text-bottom;
  color: inherit;
  text-decoration: none;
`;

/**
 * Info icon with a session related tooltip (stops not guaranteed / price may
 * gap, see intermittentMarketsCopy). Links to the intermittent markets docs
 * in a new tab. Used on the market details tab.
 */
export default function MarketSessionInfoTooltip() {
  return (
    <Tooltip
      text={MARKET_CLOSES_PERIODICALLY_LINK_TOOLTIP}
      maxWidthPx={300}
      wrapper="inlineDiv"
      pointer
      fixedPosition
    >
      <IconLink href={urls.intermittentMarketsDocs}>
        <MaterialSymbol icon="info" fontSize="inherit" />
      </IconLink>
    </Tooltip>
  );
}
